import { evaluate } from 'mathjs';

export const webTimeCalculation = (input, decimal = ',') => {
  if (!input) {
    return 0;
  }
  // Split in mathematical parts
  // Step 1
  const noSpaceInput = input.replace(/ /g, '');

  const formatedInput = noSpaceInput.replace(/[\/ \+ \- \*]/g, '|');

  const parts = formatedInput.split('|');
  const interpretation = {};

  parts.forEach((p) => {
    // // Interpret German
    // // Step 2

    // // step 1a

    // // step 1b
    // // =IF(ISERROR(D8);B1;IF(D8;LEFT(SUBSTITUTE(B1;".";"u");LEN(B1)-1)&"m";B1))
    // // D8 - isGermaWay
    // // B1 - p
    // if (isGermaWay) {
    //   convertedValue = convertedValue.replace(/\./g, 'u');
    //   convertedValue = convertedValue.substring(0, convertedValue.length - 1) + 'm';
    // }

    let convertedValue = p;
    // Step 2
    // Convert to lower case
    convertedValue = convertedValue.toLocaleLowerCase();

    // Step 3
    // Interpret German

    // step 3a (Is input in minutes? (in that case use both , and . as decimal)
    const minutesList = ['minutes', 'minuten', 'min.', 'min'];
    const step3a = minutesList.some((name) => convertedValue.indexOf(name) > -1);

    // step 3b
    // Is local setting decimal in ","?
    const isDot = p.indexOf('.') >= 0;
    const isGermaWay = Boolean(decimal === ',' && isDot);
    const step3b = isGermaWay && !step3a;

    // step 3c
    // Is this German way of writing when decimal "," is selected?
    const step3c = !step3a && step3b;

    if (step3b) {
      let initial = convertedValue;

      // step 3d
      // subtitute German splitter
      convertedValue = convertedValue.replace(/\./g, 'u');

      // step 3e
      const last = convertedValue.slice(-1);
      if ((last === 'u' || last === 'h') && step3c) {
        convertedValue = convertedValue.slice(0, -1);
      } else {
        convertedValue = initial;
      }
    }

    // Convert minutes
    // Step 4
    minutesList.forEach((name) => {
      if (convertedValue.indexOf(name) > -1) {
        convertedValue = convertedValue.replace(name, 'm');
      }
    });

    // Interpret decimal
    // Step 5
    if (decimal === '.' || step3a) {
      convertedValue = convertedValue.replace('.', ',');
    }

    // Interpret seconds
    // Step 6
    // step 6a
    // =NUMBERVALUE(D10)
    // D14 - isNumber
    const isNumber = !isNaN(Number(decimal === ',' ? convertedValue.replace(/,/g, '.') : convertedValue));

    // step 6b
    // =IF(ISERROR(D14);D10;D14)
    if (isNumber) {
      // step 6c
      // =IF(ISNUMBER(E14);D10&"s";D10)
      convertedValue = convertedValue + 's';
    }
    // Step 7
    // Step 8
    // Step 9
    let isSearch = true;
    const splited = {};
    let elPosition = 1;

    const getNumber = (value, index = 0) => {
      if (!value) {
        return {};
      }
      const el = Number(value[index]);
      if (isNaN(el)) {
        return { number: Number(value.substring(0, index)), lng: index };
      }
      return getNumber(value, index + 1);
    };

    while (isSearch) {
      let { number, lng } = getNumber(convertedValue);
      if (isNaN(number)) {
        isSearch = false;
        break;
      }

      let spliter = convertedValue.substring(lng, lng + 1);

      if (spliter === ',') {
        convertedValue = convertedValue.substring(lng + 1, convertedValue.length);
        let { number: number2, lng: lng2 } = getNumber(convertedValue);
        let spliter2 = convertedValue.substring(lng2, lng2 + 1);

        splited[elPosition] = {
          number: Number(`${number}.${number2}`),
          spliter: spliter2,
        };
        convertedValue = convertedValue.substring(lng2 + 1, convertedValue.length);
      } else {
        splited[elPosition] = {
          number,
          spliter,
        };
        convertedValue = convertedValue.substring(lng + 1, convertedValue.length);
      }

      elPosition += 1;
    }

    const spliterValue = {
      h: 3600,
      u: 3600,
      m: 60,
      s: 1,
    };
    const getAmountOfSliters = (spliter) => {
      let count = 0;
      Object.values(splited).forEach((i) => {
        if (i.spliter === spliter) {
          count += 1;
        }
      });
      return count;
    };

    const getEl1 = () => {
      if (splited['1']) {
        const el = splited['1'];
        if (spliterValue[el.spliter]) {
          return spliterValue[el.spliter] * el.number;
        }
        if (el.spliter === ':') {
          const count = getAmountOfSliters(':');
          const countM = getAmountOfSliters('m');
          if ((count === 1 && countM > 0) || count > 1) {
            return el.number * 3600;
          }
          if (count === 1 && countM === 0) {
            return el.number * 60;
          }
        }
        if (el.spliter === '.') {
          const count = getAmountOfSliters('.');
          if (count === 1) {
            return el.number * 60;
          } else {
            return el.number * 3600;
          }
        }
      }
    };

    const getEl2 = () => {
      if (splited['2']) {
        const el = splited['2'];
        if (spliterValue[el.spliter]) {
          return spliterValue[el.spliter] * el.number;
        }
        if (el.spliter === ':') {
          return el.number * 60;
        }
        if (el.spliter === '.') {
          const count = getAmountOfSliters('.');
          if (count === 1) {
            return el.number;
          } else {
            return el.number * 60;
          }
        }

        if (el.spliter === '') {
          const el1 = splited['1'];
          if (el1.spliter === 'h' || el1.spliter === 'u') {
            return el.number * 60;
          }
          if (el1.spliter === 'm') {
            return el.number;
          }
        }

        return el.number;
      }
    };

    const getEl3 = () => {
      if (splited['3']) {
        const el = splited['3'];
        if (spliterValue[el.spliter]) {
          return spliterValue[el.spliter] * el.number;
        } else {
          return el.number;
        }
      }
    };

    const el1 = getEl1();
    const el2 = getEl2();
    const el3 = getEl3();
    const elements = [el1, el2, el3];
    let seconds = 0;
    elements.forEach((e) => {
      if (e) {
        seconds += e;
      }
    });

    interpretation[p] = Math.round(seconds);
  });

  let secondsInput = noSpaceInput;
  Object.keys(interpretation).forEach((k) => {
    const v = interpretation[k];
    const regex = new RegExp(k, 'g');
    secondsInput = secondsInput.replace(regex, v);
  });
  return evaluate(secondsInput);
};
